import React from 'react';

export default function ContactMe() {
	return <div style={{display: 'felx', height: '100%'}}></div>;
}
